import { useSelector, shallowEqual } from "react-redux";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.sdpSearch,
		titleFromSanity: state.brand?.seo?.sdpHome?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.sdpHome?.metaDescription,
	};
};

const SmartDPSearchHeadMetadata = () => {
	const { robotsMetaTag, titleFromSanity, descriptionFromSanity } = useSelector(
		mapStateToProps,
		shallowEqual
	);
	const title = titleFromSanity || "page.title.sdp.home";
	const description = descriptionFromSanity || "page.description.sdp.home";

	return <HeadMetadata description={description} title={title} robotsMetaTag={robotsMetaTag} />;
};

export default SmartDPSearchHeadMetadata;
